import { IColumns } from '../../../../../../components/Dashboard/TableSmall'

export enum RiskLevel {
  Low = 'Low',
  Medium = 'Medium',
  High = 'High',
}

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'staking/balance/treasury',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'staked',
      label: 'STAKED',
    },
    {
      id: 'unclaimed',
      label: 'UNCLAIMED',
    },
    {
      id: 'total',
      label: 'TOTAL',
    },
  ],
}

export const stateData = [
  { asset: 'Asset-1', staked: '1.000.000', unclaimed: '500.000', total: 'BTC5000' },
  { asset: 'Asset-1', staked: '1.000.000', unclaimed: '500.000', total: 'BTC5000' },
  { asset: 'Asset-1', staked: '1.000.000', unclaimed: '500.000', total: 'BTC5000' },
  { asset: 'Asset-1', staked: '1.000.000', unclaimed: '500.000', total: 'BTC5000' },
]
